import { render, staticRenderFns } from "./custom-wrap.vue?vue&type=template&id=1e50faba&"
import script from "./custom-wrap.vue?vue&type=script&lang=js&"
export * from "./custom-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports